(() => {
  const THEME_AJAX_PRODUCT_ADDED = 'ajaxProduct:added'
  const QIKIFY_OPEN_POPUP = 'boosterkit-open-popup'
  const ADD_TO_CART_ACTION = 'add-to-cart'
  const CART_PATH = `${window.Shopify?.routes?.root || '/'}cart`.replace('//', '/')

  let pageCartSubmitInProgress = false

  function hasQikifyFreeGiftOffer() {
    const entries = window._BK?.entries
    return Array.isArray(entries) && entries.some((entry) => entry?.type === 'free-gift')
  }

  function hasQikifyListenerAttrs(element) {
    if (!element) return false
    return (
      element.hasAttribute('qbk-form-listener') ||
      element.hasAttribute('qbk-popup-listener') ||
      element.hasAttribute('qbk-promote-fg-listener') ||
      element.hasAttribute('qbk-form-variant-listener') ||
      element.hasAttribute('qbk-quantity-listener')
    )
  }

  function findForm(event) {
    const button = event.detail?.addToCartBtn
    return button?.closest?.('form[action*="/cart/add"]') || event.target?.querySelector?.('form[action*="/cart/add"]')
  }

  function getTriggerData(event) {
    const form = findForm(event)
    const product = event.detail?.product || {}
    const button = event.detail?.addToCartBtn || form?.querySelector?.('[name="add"], [type="submit"]')
    const variantInput = form?.querySelector?.('[name="id"]')
    const quantityInput = form?.querySelector?.('[name="quantity"]')
    const productIdInput = form?.querySelector?.('[name="product-id"]')

    const productId = product.product_id || product.productId || productIdInput?.value || window.qbkStore?.productId
    const triggerId = product.variant_id || product.variantId || product.id || variantInput?.value || window.qbkStore?.selectedId
    const triggerQuantity = Number(product.quantity || quantityInput?.value || 1) || 1

    if (!productId || !triggerId) return null

    return {
      product: {
        productId: String(productId),
        triggerId: String(triggerId),
        triggerQuantity
      },
      action: ADD_TO_CART_ACTION,
      element: button || form,
      includeFreeGift: true
    }
  }

  function openQikifyPopup(detail) {
    if (!detail || document.querySelector('.qbk-popup')) return

    window.setTimeout(() => {
      document.dispatchEvent(new CustomEvent(QIKIFY_OPEN_POPUP, { detail }))
    }, 0)
  }

  document.addEventListener(THEME_AJAX_PRODUCT_ADDED, (event) => {
    if (!hasQikifyFreeGiftOffer()) return

    openQikifyPopup(getTriggerData(event))
  })

  function getPageCartBlock(form) {
    return form?.closest?.('block-buy-buttons[data-cart-type="page"]')
  }

  function getSubmitContext(event) {
    if (event.type === 'submit') {
      const form = event.target?.closest?.('form[action*="/cart/add"]')
      if (!form) return null

      return {
        form,
        button: event.submitter || form.querySelector('[name="add"], [type="submit"]')
      }
    }

    const button = event.target?.closest?.('[name="add"], [type="submit"]')
    const form = button?.closest?.('form[action*="/cart/add"]')
    if (!form) return null

    return { form, button }
  }

  function shouldUsePageCartFallback(form, button) {
    if (!hasQikifyFreeGiftOffer()) return false
    if (!getPageCartBlock(form)) return false
    if (hasQikifyListenerAttrs(form) || hasQikifyListenerAttrs(button)) return false
    return true
  }

  function setButtonLoading(button, loading) {
    if (!button) return

    if (loading) {
      button.setAttribute('aria-busy', 'true')
      button.classList.add('btn--loading')
      button.disabled = true
    } else {
      button.removeAttribute('aria-busy')
      button.classList.remove('btn--loading')
      button.disabled = false
    }
  }

  function showError(form, message) {
    form.querySelector('.errors.text-center')?.remove()

    const errorEl = document.createElement('div')
    errorEl.className = 'errors text-center'
    errorEl.textContent = message
    form.append(errorEl)
  }

  function navigateToCart(delay = 0) {
    window.setTimeout(() => {
      window.location.href = CART_PATH
    }, delay)
  }

  function cartHasQikifyGift(cart) {
    return Array.isArray(cart?.items) && cart.items.some((item) => item?.properties?.['_qbk-offer-type'] === 'free-gift')
  }

  async function waitForQikifyGiftInCart(timeout = 5000) {
    const startedAt = Date.now()

    while (Date.now() - startedAt < timeout) {
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' }
      }).then((response) => response.json()).catch(() => null)

      if (cartHasQikifyGift(cart)) return true
      await new Promise((resolve) => window.setTimeout(resolve, 250))
    }

    return false
  }

  function installCartRedirectAfterPopup() {
    let popupSeen = false
    let redirected = false

    async function redirectOnce({ waitForGift = false, delay = 0 } = {}) {
      if (redirected) return
      redirected = true
      observer.disconnect()
      window.clearTimeout(noPopupTimer)

      if (waitForGift) await waitForQikifyGiftInCart()
      navigateToCart(delay)
    }

    function bindPopup(popup) {
      if (!popup || popupSeen) return
      popupSeen = true
      window.clearTimeout(noPopupTimer)

      popup.addEventListener(
        'click',
        (event) => {
          const control = event.target.closest('button, a')
          if (!control) return

          const text = control.textContent.trim()
          const isContinue = text === 'Continue'
          const isClose = control.matches('.qbk-popup__close, .qbk-popup__outside-btn') ||
            !!control.closest('.qbk-popup__close, .qbk-popup__outside-btn')

          if (isContinue) redirectOnce({ waitForGift: true })
          if (isClose) redirectOnce({ waitForGift: false, delay: 300 })
        },
        { capture: true }
      )
    }

    const observer = new MutationObserver(() => {
      bindPopup(document.querySelector('.qbk-popup'))
    })

    observer.observe(document.body, { childList: true, subtree: true })
    bindPopup(document.querySelector('.qbk-popup'))

    const noPopupTimer = window.setTimeout(() => {
      if (!popupSeen) redirectOnce()
    }, 5000)
  }

  async function addFormToCart(form) {
    const formData = new FormData(form)
    if (!formData.get('quantity')) formData.set('quantity', '1')

    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })

    const responseJson = await response.json().catch(() => ({}))
    if (!response.ok) throw responseJson

    return responseJson
  }

  async function handlePageCartFallback(event) {
    if (pageCartSubmitInProgress) return

    const context = getSubmitContext(event)
    if (!context) return

    const { form, button } = context
    if (!shouldUsePageCartFallback(form, button)) return

    event.preventDefault()
    event.stopImmediatePropagation()

    pageCartSubmitInProgress = true
    setButtonLoading(button, true)

    try {
      const product = await addFormToCart(form)
      const detail = getTriggerData({
        target: getPageCartBlock(form) || form,
        detail: {
          product,
          addToCartBtn: button
        }
      })

      installCartRedirectAfterPopup()
      openQikifyPopup(detail)
    } catch (error) {
      const message = error?.description || error?.message || 'Could not add to cart. Please try again.'
      showError(form, typeof message === 'string' ? message : 'Could not add to cart. Please try again.')
      pageCartSubmitInProgress = false
      setButtonLoading(button, false)
    }
  }

  document.addEventListener('click', handlePageCartFallback, true)
  document.addEventListener('submit', handlePageCartFallback, true)
})()
